export function capitalizeFirstLetter(string = '') {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/*
Examples of how titleize() works:
- traveler -> Traveler
- banana split -> Banana Split
- direct_sourcing -> Direct Sourcing
- per-diem -> Per-Diem
*/
export function titleize(string = '') {
  if (string === null) return '';

  return string
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/(?:^|\s|-)\S/g, (x: string) => x.toUpperCase());
}

/*
Examples of how humanize() works:
- banana -> Banana
- this is a test -> This is a test
- foo Bar Baz -> Foo Bar Baz
- foo_bar -> Foo bar
- foo_bar_baz -> Foo bar baz
- foo-bar -> Foo-bar
- fooBarBaz -> FooBarBaz
*/
export function humanize(string = '') {
  return string
    .replace(/^[\s_]+|[\s_]+$/g, '')
    .replace(/[_\s]+/g, ' ')
    .replace(/^[a-z]/, (m) => m.toUpperCase());
}

export function humanizeBoolean(boolean?: boolean | null) {
  if (boolean === undefined || boolean === null) {
    return undefined;
  }

  return boolean ? 'Yes' : 'No';
}
